module.exports = __webpack_public_path__ + "img/icon-linkedin.c4913372.svg";